// SignalingSocket rejects a correlated request with `message.data`, a plain object, not an
// Error — String() on that yields "[object Object]" and loses the detail telemetry needs.
const describeCause = (cause: unknown): string => {
  if (cause instanceof Error) {
    return cause.message;
  }

  try {
    return JSON.stringify(cause) ?? String(cause);
  } catch {
    return String(cause);
  }
};

// Our Janus fork lets one uniqueId authorize exactly one subscription, so a rebuild that cannot
// mint a fresh grant must abort rather than send a `join` the server will reject with 405.
export class SubscribeTokenRefreshError extends Error {
  constructor(cause: unknown) {
    super(`Subscribe grant refresh failed: ${describeCause(cause)}`);
    this.name = 'SubscribeTokenRefreshError';
  }
}

// Plugin errors that reject a subscriber `join` before any subscription exists.
export type RejectedJoinCode = 424 | 428 | 437;

// janus.js rejects a core error as "<code> <reason>"; our fork answers a spent grant with 405.
export const SUBSCRIBE_GRANT_REFUSED_CODE = 405;

export const isSubscribeGrantRefusal = (error: unknown) =>
  typeof error === 'string' && error.startsWith(`${SUBSCRIBE_GRANT_REFUSED_CODE} `);
